import { registerSW } from "virtual:pwa-register";
import { shouldEnableBrowserPwa } from "./channelHosts";
import { debugLog } from "./debugLog";

/** Register service worker only on PWA/browser host (not MAX mini-app host / WebApp). */
export function registerVisitorPwa(): void {
  if (typeof window === "undefined") return;
  if (!shouldEnableBrowserPwa()) {
    debugLog.info("pwa", "skip SW — MAX runtime or max.* host");
    return;
  }
  try {
    const updateSW = registerSW({
      immediate: true,
      onRegisteredSW(swUrl, registration) {
        debugLog.info("pwa", "SW registered", { swUrl, scope: registration?.scope });
        // Periodic check — installed PWAs otherwise keep a stale shell for days.
        if (registration) {
          window.setInterval(() => {
            void registration.update();
          }, 60_000);
        }
      },
      onRegisterError(err) {
        debugLog.warn("pwa", "SW register failed", err);
      },
      onNeedRefresh() {
        debugLog.info("pwa", "new version available — activating");
        void updateSW(true);
      },
      onOfflineReady() {
        debugLog.info("pwa", "offline ready (app shell cached)");
      },
    });
  } catch (err) {
    debugLog.warn("pwa", "registerSW threw", err);
  }
}

export function isStandalonePwa(): boolean {
  if (typeof window === "undefined") return false;
  const mq = window.matchMedia?.("(display-mode: standalone)")?.matches;
  const ios =
    "standalone" in navigator &&
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
  return Boolean(mq || ios);
}
